import { __awaiter, __decorate, __extends, __generator } from "tslib";
import { body } from "@pnp/odata";
import { _GraphQueryableCollection, _GraphQueryableInstance, graphInvokableFactory } from "../graphqueryable.js";
import { defaultPath, deleteable, updateable, getById } from "../decorators.js";
import { graphPost } from "../operations.js";
import { calendarView, instances } from "./funcs.js";
/**
 * Calendar
 */
var _Calendar = /** @class */ (function (_super) {
    __extends(_Calendar, _super);
    function _Calendar() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.calendarView = calendarView;
        return _this;
    }
    Object.defineProperty(_Calendar.prototype, "events", {
        get: function () {
            return Events(this);
        },
        enumerable: false,
        configurable: true
    });
    return _Calendar;
}(_GraphQueryableInstance));
export { _Calendar };
export var Calendar = graphInvokableFactory(_Calendar);
/**
 * Calendars
 */
var _Calendars = /** @class */ (function (_super) {
    __extends(_Calendars, _super);
    function _Calendars() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    _Calendars = __decorate([
        defaultPath("calendars"),
        getById(Calendar)
    ], _Calendars);
    return _Calendars;
}(_GraphQueryableCollection));
export { _Calendars };
export var Calendars = graphInvokableFactory(_Calendars);
/**
 * Event
 */
var _Event = /** @class */ (function (_super) {
    __extends(_Event, _super);
    function _Event() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.instances = instances;
        return _this;
    }
    _Event = __decorate([
        deleteable(),
        updateable()
    ], _Event);
    return _Event;
}(_GraphQueryableInstance));
export { _Event };
export var Event = graphInvokableFactory(_Event);
/**
 * Events
 */
var _Events = /** @class */ (function (_super) {
    __extends(_Events, _super);
    function _Events() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * Adds a new event to the collection
     *
     * @param properties The set of properties used to create the event
     */
    _Events.prototype.add = function (properties) {
        return __awaiter(this, void 0, void 0, function () {
            var data;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, graphPost(this, body(properties))];
                    case 1:
                        data = _a.sent();
                        return [2 /*return*/, {
                                data: data,
                                event: this.getById(data.id),
                            }];
                }
            });
        });
    };
    _Events = __decorate([
        defaultPath("events"),
        getById(Event)
    ], _Events);
    return _Events;
}(_GraphQueryableCollection));
export { _Events };
export var Events = graphInvokableFactory(_Events);
//# sourceMappingURL=types.js.map